import { render, staticRenderFns } from "./DetailsPanel.vue?vue&type=template&id=1ef3a6f1&scoped=true&"
import script from "./DetailsPanel.vue?vue&type=script&lang=ts&"
export * from "./DetailsPanel.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsPanel.vue?vue&type=style&index=0&id=1ef3a6f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef3a6f1",
  null
  
)

export default component.exports